import React, { useState, useEffect } from "react";
import { StaticImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import '../../sass/components/flexibleModules/_components.gridWithCarouselOnMobile.scss';
import "../../sass/slick/slick.min.scss";
import "../../sass/slick/slick-theme.min.scss";

const GridWithCarouselOnMobile = ({ data }) => {

    let mediaQueryMax = null;
    let mediaQueryMin = null;
    if (typeof window !== "undefined") {
        mediaQueryMax = window.matchMedia("(max-width: 620px)");
        mediaQueryMin = window.matchMedia("(min-width: 621px)");
    }

    const [isRendered, setIsRendered] = useState(false);

    let settings = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        centerMode: false,
        swipeToSlide: true,
        touchThreshold: 250,
    };

    useEffect(() => {
        setIsRendered(true);
    }, []);

    return (
        <div className="cp-gridWithCarouselOnMobile" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-gridWithCarouselOnMobile__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.gridSectionWithCarouselOnMobileHeader &&
                    <h2 dangerouslySetInnerHTML={{ __html: data.gridSectionWithCarouselOnMobileHeader }} />
                }
                {data.gridSectionWithCarouselOnMobileTeaser &&
                    <p dangerouslySetInnerHTML={{ __html: data.gridSectionWithCarouselOnMobileTeaser }} />
                }
                <div className="cp-gridWithCarouselOnMobile__grid l--flex">
                    {data.gridSectionWithCarouselOnMobileGridSections &&
                        <>
                            {typeof window !== "undefined" &&
                                <>
                                    {mediaQueryMax.matches ?
                                        <>
                                            {isRendered &&
                                                <div className="cp-gridWithCarouselOnMobile__grid-slider">
                                                    <Slider {...settings}>
                                                        {data.gridSectionWithCarouselOnMobileGridSections.map((carouselSection, index) => (
                                                            <div className="cp-gridWithCarouselOnMobile__grid-section" key={index}>
                                                                {carouselSection.icon &&
                                                                    // <GatsbyImage image={getImage(carouselSection.icon.gatsbyImage)} alt={carouselSection.icon.altText} />
                                                                    <img src={carouselSection.icon.sourceUrl} alt={carouselSection.icon.altText} />
                                                                }
                                                                {carouselSection.header &&
                                                                    <h3 dangerouslySetInnerHTML={{ __html: carouselSection.header }} />
                                                                }
                                                                {carouselSection.teaser &&
                                                                    <p dangerouslySetInnerHTML={{ __html: carouselSection.teaser }} />
                                                                }
                                                                {carouselSection.link &&
                                                                    <a href={carouselSection.link.url} target={carouselSection.link.target}>
                                                                        <span>{carouselSection.link.title}</span>
                                                                        <StaticImage src="../../images/arrow-pro-right.svg" alt="" />
                                                                    </a>
                                                                }
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                </div>
                                            }
                                        </>
                                        :
                                        <>
                                            {
                                                data.gridSectionWithCarouselOnMobileGridSections.map((carouselSection, index) => (
                                                    <div className="cp-gridWithCarouselOnMobile__grid-section" key={index}>
                                                        {carouselSection.icon.sourceUrl &&
                                                            <img loading="lazy" src={carouselSection.icon.sourceUrl} alt={carouselSection.icon.altText} />
                                                        }
                                                        {/* <GatsbyImage image={getImage(carouselSection.icon.gatsbyImage)} alt={carouselSection.icon.altText} /> */}
                                                        {carouselSection.header &&
                                                            <h3 dangerouslySetInnerHTML={{ __html: carouselSection.header }} />
                                                        }
                                                        {carouselSection.teaser &&
                                                            <p dangerouslySetInnerHTML={{ __html: carouselSection.teaser }} />
                                                        }
                                                        {carouselSection.link &&
                                                            <a href={carouselSection.link.url} target={carouselSection.link.target}>
                                                                <span>{carouselSection.link.title}</span>
                                                                <StaticImage src="../../images/arrow-pro-right.svg" alt="" />
                                                            </a>
                                                        }
                                                    </div>
                                                ))
                                            }
                                        </>
                                    }
                                </>
                            }
                        </>
                    }
                </div>
            </div>
        </div>
    );
}

export default GridWithCarouselOnMobile;